import React, { useMemo } from "react";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { Card, FormLabel, Grid } from "@mui/material";

import CardBody from "../../../../components/Card/CardBody";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import FormFile from "../../../../components/Forms/FormFile";

function Micros3700() {
  const orderMode = useMemo(
    () => [
      { value: 1, label: "Table" },
      { value: 2, label: "Delivery" },
    ],
    []
  );

  const orderModeOptions = useMemo(() => convertObjectToSelectOptions(orderMode), []);
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <FormTextTC
              name={"apiaccounts__microsEndpoint"}
              tDefault={"Endpoint"}
              tKey={"vestigingen.form.micros3700.label.microsEndpoint"}
            />
            <FormSelectTC
              name={"apiaccounts__microsOrderMode"}
              options={orderModeOptions}
              tDefault={"Order mode"}
              tKey={"vestigingen.form.micros.label.orderMode"}
            />
            <FormTextTC
              name={"apiaccounts__microsUser"}
              tDefault={"Api User"}
              tKey={"vestigingen.form.micros3700.label.microsUser"}
            />
            <FormTextTC
              name={"apiaccounts__microsTender"}
              tDefault={"Tender id"}
              tKey={"vestigingen.form.micros3700.label.microsTender"}
            />
            <FormTextTC
              name={"apiaccounts__microsCheckOrderType"}
              tDefault={"Order type id"}
              tKey={"vestigingen.form.micros3700.label.microsCheckOrderType"}
            />
            <FormTextTC
              name={"apiaccounts__microsRevenueCenter"}
              tDefault={"Revenue center nummer"}
              tKey={"vestigingen.form.micros3700.label.microsRevenueCenter"}
            />
            <FormTextTC
              name={"apiaccounts__microsTender"}
              tDefault={"Tender id"}
              tKey={"vestigingen.form.micros3700.label.microsTender"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <Grid item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper
                  tDefault={"Menu items (csv)"}
                  tKey={"vestigingen.form.apiaccounts.label.micros_menuitems"}
                />
              </FormLabel>
            </Grid>
            <Grid item sm={8} xs={12}>
              <FormFile name={"micros_menuitems"} nullable={false} />
            </Grid>
            <Grid item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper
                  tDefault={"Condiments (csv)"}
                  tKey={"vestigingen.form.apiaccounts.label.micros_condiment"}
                />
              </FormLabel>
            </Grid>
            <Grid item sm={8} xs={12}>
              <FormFile name={"micros_condiments"} nullable={false} />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Micros3700;
